import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../LanguageContext';
import { FaSolarPanel, FaLeaf, FaBolt, FaHeart } from 'react-icons/fa';

const Footer = () => {
  const { language } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden" data-testid="footer">
      {/* Animated background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-solar-500 rounded-full blur-3xl animate-pulse-slow" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-energy-500 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '1s' }} />
      </div>

      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-solar-400 to-energy-500 rounded-full flex items-center justify-center">
                <FaSolarPanel className="text-white text-xl" />
              </div>
              <span className="font-bold text-xl">PI ENERGI</span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              {language === 'en'
                ? 'Renewable energy company focused on sustainable solar power generation in North Macedonia.'
                : 'Компанија за обновлива енергија фокусирана на одржливо производство на сончева енергија во Северна Македонија.'}
            </p>
          </div>

          {/* Values */}
          <div>
            <h3 className="font-bold text-lg mb-4">
              {language === 'en' ? 'Our Values' : 'Наши вредности'}
            </h3>
            <div className="space-y-3">
              {[
                { icon: FaLeaf, text: language === 'en' ? 'Sustainability' : 'Одржливост' },
                { icon: FaBolt, text: language === 'en' ? 'Innovation' : 'Иновација' },
                { icon: FaHeart, text: language === 'en' ? 'Responsibility' : 'Одговорност' },
              ].map((item, index) => (
                <motion.div
                  key={index}
                  whileHover={{ x: 5 }}
                  className="flex items-center space-x-3 text-gray-300"
                >
                  <item.icon className="text-solar-400" />
                  <span className="text-sm">{item.text}</span>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">
              {language === 'en' ? 'Contact' : 'Контакт'}
            </h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p>Goce Delecev no. 3</p>
              <p>Resen, North Macedonia</p>
              <p className="pt-2">
                <a href="tel:+38971204333" className="hover:text-solar-400 transition-colors">
                  +389 71 204 333
                </a>
              </p>
              <p>
                <a href="mailto:pienergi@hotmail.com" className="hover:text-solar-400 transition-colors">
                  pienergi@hotmail.com
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-700 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              &copy; {currentYear} PI ENERGI DOOEL Resen. {language === 'en' ? 'All rights reserved.' : 'Сите права задржани.'}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;